<template>
  <button class="btn-icon">
      <slot></slot>
  </button>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/variables.scss';

$btn-padding: $sp-margin;

.btn-icon {
  background: $primary;
  border-radius: 50%;
  border: 0;
  color: $white;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    background: $primary-dark2;
  }
  &:active {
    background: $primary-dark3;
    outline: 0;
  }
  &:focus {
    outline: $link-dark solid 3px;
    outline-offset: 2px;
  }
  &[disabled] {
    opacity: 0.25;
    pointer-events: none;
  }

  &[btn-size='xs'] {
    padding: $sp;
    > svg {
      width: $sp * 4;
      height: $sp * 4;
    }
  }
  &[btn-size='s'] {
    padding: $sp * 1.5;
    > svg {
      width: $sp * 5;
      height: $sp * 5;
    }
  }
  &[btn-size='m'] {
    padding: $sp * 2;
    > svg {
      width: $sp * 6;
      height: $sp * 6;
    }
  }
  &[btn-size='l'] {
    padding: $sp * 3;
    > svg {
      width: $sp * 9;
      height: $sp * 9;
    }
  }

  &[btn-type='secondary'] {
    background-color: transparent;
    border: 1px solid $black-trans2;
    color: $black-trans2;
    &:hover {
      border: 1px solid $black-trans6;
      color: $black-trans6;
    }
  }
  &[btn-inverse] {
    border-color: $white-trans2;
    color: $white-trans2;
    &:hover {
      border: 1px solid $white-trans6;
      color: $white-trans6;
    }
  }

  .icon-before > svg {
    margin-right: $sp-margin-smaller;
  }
  .icon-after > svg {
    margin-left: $sp-margin-small;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/buttons/BtnIcon.vue